import { defineAsyncComponent } from 'vue'
export default {
  "blog-owner": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/blog-owner.vue").then(m => m.default || m)),
  "blog-post": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/blog-post.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m))
}